define(['jquery', 'app/tools'], function ($, tools) {
  var isTablet = tools.isTablet();

  $.fn.pkoSelect = function (_options) {

    var options = $.extend({}, $.fn.pkoSelect.defaults, _options),
      $body = $('body');


    if (!isTablet) {
      $body.on('click.closeSelectDropdown', function () {
        var $dropdown = $('.' + options.dropdownClass),
          $this;

        $dropdown.each(function () {
          $this = $(this);
          if ($this.hasClass(options.openClass)) {
            $this.removeClass(options.openClass).slideUp();
          }
        });

      });

      $body.on('click.openSelectDropdown', '.' + options.wrapClass, function () {
        var $dropdown = $(this).find('.' + options.dropdownClass);
        if ($dropdown.is(':animated')) return true;

        if (!$dropdown.is(':visible')) {
          $dropdown.slideDown(function () {
            $dropdown.addClass(options.openClass);
          });
        }
      });
    }

    var setUp = function (elem) {

      var $elem = $(elem),
        $options = $elem.find('option'),
        $dropdown, $dropdownList, $dropdownItem, $dropdownLink;

      $elem.wrap('<div class="' + options.wrapClass + '"></div>').after('<div class="' + options.wrapValueClass + '"></div>')
        .on('change', function () {
          var text = $elem.find(':selected').text();
          $elem.siblings('.' + options.wrapValueClass).text(text);
        })
        .triggerHandler('change');


      if (!isTablet) {
        $elem.addClass('hidden');

        $dropdown = $('<div>').addClass(options.dropdownClass + ' ' + options.hiddenClass);
        $dropdownList = $('<ul>').addClass(options.dropdownListClass);

        $.each($options, function () {
          if (/wybierz|-/gi.test($(this).text())) return true;

          $dropdownLink = $('<a>').addClass(options.dropdownListItemClass).append($(this).text());
          $dropdownItem = $('<li>').append($dropdownLink);
          $dropdownList.append($dropdownItem);
        });

        $dropdown.append($dropdownList).css({top: $elem.outerHeight(true)}).insertAfter($elem);

        $dropdownList.on('click', '.' + options.dropdownListItemClass, function (e) {
          e.preventDefault();
          var mod = $options.eq(0).val() ? 0 : 1;

          $options.eq($(this).parent('li').index() + mod).prop('selected', true);
          $elem.triggerHandler('change');
        });
      }

    };

    return this.each(function () {
      setUp(this);
    });

  };

  $.fn.pkoSelect.defaults = {
    wrapClass: 'form-select-wrap',
    wrapValueClass: 'form-select-wrap__value',

    dropdownClass: 'form-select__dropdown',
    dropdownListClass: 'form-select__list',
    dropdownListItemClass: 'form-select__item',
    hiddenClass: 'hidden',
    openClass: 'open'
  };

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/lib/jquery.pkoSelect.js